

export default function useViabilityCalculator() {

  const updateHa = (area: string) => {
    var value = parseFloat(area.split(' ')[0])
    var type = area.split(' ')[1]
    if (type === 'm²' && value !== undefined) {
      value = value / 10000
    }
    return value;
  }
  
  return {
    updateHa,
  }  
}
